import { Application } from "./nav.config";

export const getContactUrl = (application: Application, isLocalHost?: boolean) => {
    if (isLocalHost) {
        return 'https://pickleball.freshdesk.com/en/support/home';
    } else if (application === 'tournament') {
        return 'https://pickleballtournaments-help.freshdesk.com/en/support/home';
    } else if (application === 'clubs') {
        return 'https://pickleballclubs.freshdesk.com/en/support/home';
    } else if (application === 'leagues') {
        return 'https://pickleballleagues.freshdesk.com/en/support/home';
    }
    return 'https://pickleball.freshdesk.com/en/support/home';
}
